<template>
  <div class="ticket-booking__buy-container">
    <div v-if="!dateIsSelected || ticketNeedsNoDate" class="ticket-booking__buy-container-info">
      <span>{{ parsedLabels.main['daily-updated-price-label'] }}</span>
      <strong>{{ formattedCurrentPrice  }} €</strong>
    </div>

    <CalendarSidebarDates v-else-if="dateIsSelected && ticketNeedsNoDate === false"
                          :dateFrom="dateFrom"
                          :dateTo="dateTo"
                          :sidebar-labels="parsedLabels.sidebar"
                          :initialShownPrice="formattedInitialShownPrice"
                          style-class="d-md-none"/>

    <button type="button" class="btn btn-primary ticket-booking__buy-step-btn step-2 w-100 js-overlay-toggle"
            data-overlay-toggle-target="ticketSidebar"
            data-overlay-toggle-class="overlay-step-2"
            :disabled="!dateIsSelected">{{ parsedLabels.main['next-label'] }}</button>
  </div>
  <div class="cal-wrapper container">
    <div :class="{ 'is-loading': isLoading }">
      <div class="cal-top mb-md-4 mb-2">
        <div></div>

        <div class="cal-top__choosen-date">
          <div class="title-block">
            <div class="h2 title js-toc__title">{{ ticketName }}</div>
            <div class="sub-title h3">
              {{ ticketSubTitle }}
            </div>
          </div>

          <template v-if="dateIsSelected && ticketNeedsNoDate === false">
            <CalendarSidebarDates
                :dateFrom="dateFrom"
                :dateTo="dateTo"
                :sidebar-labels="parsedLabels.sidebar"
                style-class="d-md-flex d-none"/>
          </template>

        </div>
      </div>

      <div class="cal-container">
        <div v-if="ticketNeedsNoDate === false" class="cal-main">
          <div class="cal-title h6 mb-2">1. {{ parsedLabels.main['choose-date-headline'] }}</div>

          <Calendar
              @date-selected="dateSelected"
              @fetch-dates-complete="datesFetched"
              @switch-month="setLoadingStatus(true)"
              :dates-url="datesUrl"
              :totalPrice="totalPrice"
              :updated-dates="dateList"
              :max-selection="maxSelection"
              :min-selection="minSelection"
              :initial-date="initDate"
              :last-date="lastDate"
              :header-labels="parsedLabels.header"
              :weekday-labels="parsedLabels.weekdays"
              :main-labels="parsedLabels.main"
          />

            <div class="mt-4">
              <div class="cal-info" v-if="hasStaticPrices === false">
                <span class="icon icon-info" aria-hidden="true"></span>
                <span v-html="pricingInfo"></span>
              </div>
              <div class="cal-info" v-if="showDurationInfo && hasStaticPrices === false">
                <span class="cal-info__circle" aria-hidden="true"></span>
                <span v-html="durationInfo"></span>
              </div>
              <div class="cal-info" v-if="showBestPriceInfo && hasStaticPrices === false">
                <span class="cal-info__bestprice" aria-hidden="true"></span>
                <span v-html="bestPriceInfo"></span>
              </div>

              <a v-if="hasStaticPrices === false"
                 class="scroll-link scroll-link--cal js-smoothscroll__link js-overlay-toggle"
                 href="#idDynamicPricingInfo"
                 data-scroll-offset="100"
                 data-overlay-toggle-media-query="(max-width: 767px)"
                 data-overlay-toggle-target="ticketCalendar"
                 data-overlay-toggle-class="overlay-step-1">
                <span class="icon icon-arrow-right icon-rotate-90" aria-hidden="true"></span>
                <span class="scroll-link__text">
                  {{ parsedLabels.main['dynamic-pricing-info-label'] }}
                </span>
              </a>

            </div>

        </div>
        <div v-else class="cal-main">
          <div class="cal-content" v-html="noDateDescription"></div>
        </div>
        <CalendarSidebar
            :holder-id="holderId"
            :is-bookable="isBookable"
            :cart-url="cartUrl"
            :ticket-id="ticketId"
            :ticketName="ticketName"
            :person-types="personTypes"
            :bookable-options="bookableOptions"
            :dateFrom="dateFrom"
            :dateTo="dateTo"
            :class="{ 'is-started': dateIsSelected }"
            :sidebarLabels="parsedLabels.sidebar"
            :is-mapped-package="isMappedPackage"
            :static-price="staticPrice"
            :initial-adult-count="initialAdultCount"
            :initial-child-count="initialChildCount"
            :initial-senior-count="initialSeniorCount"
            @person-type-count-changed="updatePersonTypes"
        />
      </div>
    </div>
  </div>
</template>


<script setup>
import Calendar from './components/Calendar.vue';
import CalendarSidebar from './components/CalendarSidebar.vue';
import CalendarSidebarDates from './components/CalendarSidebarDates.vue';
</script>

<script>
import * as overlayToggle from "../../../scripts/overlay-toggle";

let MOREDAYS_TICKET_URL = 'http://localhost:5173/src/data/more-days-ticket.json';

export default {
  props: {
    datesUrl: String,
    ticketUrl: String,
    cartUrl: String,
    maxSelection: Number,
    minSelection: Number,
    initialDate: {
      type: [String],
      required: false,
      default: null,
    },
    holderId: Number,
    lastDate: String,
    labels: String,
    ticketCount: Number,
    currentPrice: {
      type: Number,
      required: false,
      default: null
    },
    ticketNeedsNoDate: Boolean,
    hasStaticPrices: Boolean,
    staticPrice: Number,
    isDebug: Boolean,
    noDateDescription: String,
    isBookable: Boolean,
    initialAdultCount: Number,
    initialChildCount: Number,
    initialSeniorCount: Number
  },
  mounted() {
    if (this.ticketNeedsNoDate) {
      this.dateSelected(this.initialDate, this.initialDate);
    }

    this.initDate = null;
    overlayToggle.init();
  },
  computed: {
    formattedCurrentPrice() {

      if (!this.currentPrice) {
        return '-';
      }

      return this.currentPrice.toLocaleString('de-DE', { minimumFractionDigits: 2 });
    },
    formattedInitialShownPrice() {
      return this.initalShownPrice.toLocaleString('de-DE', { minimumFractionDigits: 2 });
    },
  },
  methods: {
    async dateSelected(dateFrom, dateTo, shownMonth, shownYear) {
      this.isLoading = true;

      let ticketUrl = this.ticketUrl;
      if(ticketUrl === 'http://localhost:5173/src/data/ticket.json' && dateFrom !== dateTo){
        ticketUrl = MOREDAYS_TICKET_URL;
      }

      let fetchTicketUrl = new URL(ticketUrl),
          fetchTicketUrlParams = { dateFrom: dateFrom, dateTo: dateTo, shownMonth: shownMonth, shownYear: shownYear, persons: {} };

      const url = new URL(window.location);
      if (url.searchParams.has('date')) {
        url.searchParams.set('date', dateFrom);
      } else {
        url.searchParams.append('date', dateFrom);
      }
      // Update the browser URL with the new parameters
      window.history.pushState({}, '', url.toString());

      if (this.personTypes.length > 0) {
        this.personTypes.forEach((personType) => {
          fetchTicketUrlParams.persons[personType.personTypeObjectId] = personType.quantity;
        });
      } else {
        fetchTicketUrlParams.personStr = this.initialAdultCount + '-' + this.initialChildCount + '-' + this.initialSeniorCount;
      }

      for (const prop in fetchTicketUrlParams) {

        if (typeof fetchTicketUrlParams[prop] === 'object') {
          Object.entries(fetchTicketUrlParams[prop]).forEach(([key, value]) => {
            fetchTicketUrl.searchParams.append(prop + '['+key+']', value);
          });
        } else {
          fetchTicketUrl.searchParams.append(prop, fetchTicketUrlParams[prop]);
        }
      }

      const selRespData = await (await fetch(fetchTicketUrl)).json();

      this.dateFrom = selRespData.dateFrom;
      this.dateTo = selRespData.dateTo;
      this.ticketId = parseInt(selRespData.ticketId, 10);
      this.ticketName = selRespData.ticketName;
      this.personTypes = selRespData.personTypes;
      this.bookableOptions = selRespData.options;
      this.totalPrice = selRespData.totalPrice;
      this.dateList = selRespData.dates;
      this.personTypeName = selRespData.basePersonType ? selRespData.basePersonType : '';
      this.isMappedPackage = selRespData.isMappedPackage ? selRespData.isMappedPackage : false;
      this.isLoading = false;

      this.updatePricingInfo();

      this.dateIsSelected = true;

      if(this.personTypes.length > 0){
        this.initalShownPrice = parseFloat(this.personTypes[0].price);
      }
    },
    datesFetched(ticketName, personTypeName) {

      this.personTypeName = personTypeName;

      this.updatePricingInfo();
      this.setLoadingStatus(false);
    },
    setLoadingStatus(status) {
      this.isLoading = status;
    },
    updatePricingInfo() {
      this.pricingInfo = this.parsedLabels.header['info-pricing'].replace('%t', this.ticketName).replace('%p', this.personTypeName);
    },
    updatePersonTypes(values) {
      this.personTypes.forEach((personType) => {

        let objId = personType.personTypeObjectId;

        if(values[objId]){
          personType.quantity = values[objId].amount;
        }
      });
    }
  },
  data() {
    let parsedLabels = JSON.parse(this.labels);

    let bestPriceInfoLabel = parsedLabels.header['info-bestprice'];
    let showBestPriceInfo = !!bestPriceInfoLabel;

    return {
      ticketId: 0,
      ticketName: '',
      ticketSubTitle: '',
      totalPrice: '',
      personTypes: [],
      bookableOptions: [],
      dateFrom: [
        {
          "day": "",
          "monthYear": "",
          "weekday": ""
        }
      ],
      dateTo: [
        {
          "day": "",
          "monthYear": "",
          "weekday": ""
        }
      ],
      dateList: [],
      isLoading: true,
      isMappedPackage: false,
      initDate: this.initialDate,
      personTypeName: '',
      pricingInfo: '-',
      durationInfo: parsedLabels.header['info-duration'].replace('%d', this.maxSelection),
      bestPriceInfo: bestPriceInfoLabel,
      showDurationInfo: this.ticketCount > 1,
      showBestPriceInfo: showBestPriceInfo,
      dateIsSelected: false,
      initalShownPrice: '',
      isCartBtnDisabled: true,
      parsedLabels: parsedLabels,
      adultCount: this.initialAdultCount,
      childCount: this.initialChildCount,
      seniorCount: this.initialSeniorCount
    }
  }
}
</script>